import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "tw-space-y-2" };
const _hoisted_2 = { class: "tw-space-y-2" };
const _hoisted_3 = { class: "tw-space-y-2" };
const _hoisted_4 = { class: "tw-space-y-2" };
import Sports from './Sports.vue';
import Casino from './Casino.vue';
import Deposit from './Deposit.vue';
import Withdrawals from './Withdrawals.vue';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useI18n } from 'vue-i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Tabs',
    setup(__props) {
        const { t } = useI18n();
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Tabs), {
                "default-value": "sport",
                class: "tw-w-full !tw-space-y-0 tab-parent-lan"
            }, {
                default: _withCtx(() => [
                    _createVNode(_unref(TabsList), { class: "tw-w-full tw-px-4 !tw-bg-[#7b7b7b21] tw-rounded-none !tw-flex !tw-items-start !tw-justify-start tw-flex-wrap sm:tw-flex-nowrap" }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(TabsTrigger), {
                                class: "tw-py-3 tw-px-4 tw-text-[var(--foreground)]",
                                value: "sport"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('sport')), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(TabsTrigger), {
                                class: "tw-py-3 tw-px-4 tw-text-[var(--foreground)]",
                                value: "casino"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('casino')), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(TabsTrigger), {
                                class: "tw-py-3 tw-px-4 tw-text-[var(--foreground)]",
                                value: "deposit"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('deposit')), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(TabsTrigger), {
                                class: "tw-py-3 tw-px-4 tw-text-[var(--foreground)]",
                                value: "withdrawals"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('withdrawals')), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_unref(TabsContent), { value: "sport" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createVNode(Sports)
                            ])
                        ]),
                        _: 1
                    }),
                    _createVNode(_unref(TabsContent), { value: "casino" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(Casino)
                            ])
                        ]),
                        _: 1
                    }),
                    _createVNode(_unref(TabsContent), { value: "deposit" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(Deposit)
                            ])
                        ]),
                        _: 1
                    }),
                    _createVNode(_unref(TabsContent), { value: "withdrawals" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode(Withdrawals)
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
